<bn-loading-overlay></bn-loading-overlay>
<h5>Limite disponível para honra</h5>

<div class="container">
  <form [formGroup]="pesquisaForm" class="mt-3 mx-auto" (keyup.enter)="focusableSubmit.click()">
    <div class="row">
      <div class="col">
        <h3>Filtros de pesquisa</h3>
      </div>
      <div class="col-auto">
        <button #focusableSubmit type="button" class="btn btn-success" (keydown.enter)="buscar()" (click)="buscar()"
        [disabled]="!ideTranche || !pesquisaForm.valid">Pesquisar</button>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <label class="form-label" for="agenteFinanceiro">Agente Financeiro:</label>
        <select *ngIf="podeEscolherAgente" (change)="atribuiAgenteFinanceiro($event.target.value)" id="agenteFinanceiro" class="form-select">
            <option [value]="-1" selected>Todos</option>
            <option *ngFor="let agente of agentesFinanceiros" [value]="agente.cnpj">{{ agente.nome }}</option>
        </select>
        <select *ngIf="!podeEscolherAgente" disabled (change)="atribuiAgenteFinanceiro($event.target.value)" id="agenteFinanceiro" class="form-select">
            <ng-container *ngFor="let agente of agentesFinanceiros">
                <option selected *ngIf="agente.cnpj == cnpjUsuario" [value]="agente.cnpj">{{ agente.nome }}</option>
            </ng-container>
        </select>
      </div>
      <div class="bn-form-group col-md-3">
        <label class="form-label" for="tranche">Cesta:</label>
        <select (change)="atribuiTranche($event.target.value)" formControlName="tranche" id="tranche" class="form-select">
          <option value="" 			></option>
          <option *ngFor="let tranche of tranches" [value]="tranche.id">{{tranche.numeroTranche}} ({{tranche.dataInicioContratacao | date: 'dd/MM/yyyy'}})</option>
        </select>
      </div>
      <div class="bn-form-group col-md-3">
        <label class="form-label" for="nomeJanela">Mês de apuração: <i class="fa fa-question-circle help-subtitulo" placement="bottom"
          ngbTooltip="Mês/Ano (MM/AAAA) em que a apuração do Stop Loss foi realizada"></i></label>
        <input class="form-control" bnMask="MESANO" formControlName="nomeJanela">
      </div>
    </div>
  </form>
</div>

<app-stoploss-listagem 
  [agenteFinanceiro]="agenteFinanceiroPesquisa"
  [janelaReferencia]="janelaReferenciaPesquisa" 
  [refresh]="refresh" 
  [ideTranche]="ideTranche" 
  [tranches]="tranches">
</app-stoploss-listagem>
